import React from "react";
import { useParams } from "react-router-dom";
import featureContent from "../data/featureContent";
import FeatureTemplate from "./FeatureTemplate";
import { Helmet } from "react-helmet-async";
import { getPageMetadata, getFullUrl, SITE_CONFIG } from "../utils/metadata";

const FeaturePage = () => {
  const { slug } = useParams();
  const feature = featureContent.find((item) => item.slug === slug);

  if (!feature) {
    const metadata = getPageMetadata({
      title: "Feature Not Found",
      description:
        "The requested feature page does not exist on LetsGetVisa.",
      path: `/features/${slug}`,
      noindex: true,
    });

    return (
      <>
        <Helmet>
          <title>{metadata.title}</title>
          <meta name="title" content={metadata.title} />
          <meta name="description" content={metadata.description} />
          <meta name="robots" content="noindex, nofollow" />

          <meta property="og:type" content="website" />
          <meta property="og:url" content={metadata.url} />
          <meta property="og:title" content={metadata.title} />
          <meta property="og:description" content={metadata.description} />
          <meta property="og:image" content={metadata.image} />
          <meta property="og:site_name" content={SITE_CONFIG.name} />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:url" content={metadata.url} />
          <meta name="twitter:title" content={metadata.title} />
          <meta name="twitter:description" content={metadata.description} />
          <meta name="twitter:image" content={metadata.image} />
        </Helmet>
        <div>Feature not found!</div>
      </>
    );
  }

  const metadata = getPageMetadata({
    title: feature.title,
    description: feature.description || SITE_CONFIG.description,
    path: `/features/${slug}`,
    image: feature.image,
  });

  return (
    <>
      <Helmet>
        <title>{metadata.title}</title>
        <meta name="title" content={metadata.title} />
        <meta name="description" content={metadata.description} />

        <meta property="og:type" content="website" />
        <meta property="og:url" content={metadata.url} />
        <meta property="og:title" content={metadata.title} />
        <meta property="og:description" content={metadata.description} />
        <meta property="og:image" content={metadata.image} />
        <meta property="og:site_name" content={SITE_CONFIG.name} />
        <meta property="og:locale" content={SITE_CONFIG.locale} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content={metadata.url} />
        <meta name="twitter:title" content={metadata.title} />
        <meta name="twitter:description" content={metadata.description} />
        <meta name="twitter:image" content={metadata.image} />
        {SITE_CONFIG.twitterHandle && (
          <meta name="twitter:creator" content={SITE_CONFIG.twitterHandle} />
        )}

        <link rel="canonical" href={metadata.url} />
      </Helmet>
      <FeatureTemplate
        title={feature.title}
        description={feature.description}
        image={feature.image}
        sections={feature.sections}
        buttonLabel={feature.buttonLabel}
      />
    </>
  );
};

export default FeaturePage;
